<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-if="campaignData !== null">
      <div class="content">
        <div class="row" style="margin-left: 25px">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
          <p-button
            @click="editCampaignDetailsModal = true"
            round
            outline
            type="info"
            style="margin-left: 10px"
            size="sm"
            >Edit Campaign</p-button
          >
          <p-button
            @click="
              $router.push('/influencer-campaign/list/' + campaignData._id)
            "
            round
            outline
            type="info"
            size="sm"
            >View Influencers</p-button
          >
        </div>
        <div class="row">
          <div class="col-md-12">
            <div
              class="alert alert-dismissible fade show"
              :class="alertType"
              v-if="showAlert == true"
              style="width: 100%"
            >
              <div v-for="alert in alertMsg" :key="alert">
                <button
                  type="button"
                  aria-hidden="true"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <i class="nc-icon nc-simple-remove"></i>
                </button>

                <span>{{ alert }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header" style="width: 100%">
                <div style="width: 50%">
                  <h5 class="card-title" style="float: left">
                    {{ campaignData.name }}
                  </h5>
                </div>
                <div class="col-md-3 ml-auto" style="text-align: right">
                  <p-button
                    @click="editCampaignDetailsModal = true"
                    link
                    type="info"
                    style="margin-left: 10px"
                  >
                    <i class="fa fa-pen"></i> Edit
                  </p-button>
                </div>
              </div>
              <div class="card-body">
                <div class="typography-line">
                  <p>
                    <span>Campaign Name</span>
                    {{ campaignData.name }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Description</span>
                    {{ campaignData.campaignDescription }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Start Date</span>
                    {{ campaignStartString }}
                  </p>
                </div>
                <div class="typography-line">
                  <p>
                    <span>End Date</span>
                    {{ campaignEndString }}
                  </p>
                </div>
                <div class="typography-line" v-if="campaignShop !== null">
                  <div if v-if="typeof campaignShop !== 'undefined'">
                    <p>
                      <span>Shopify Url:</span>
                      {{ campaignShop }}
                    </p>
                  </div>
                </div>
                <div class="typography-line">
                  <p>
                    <span>Influencers</span>
                    {{ campaignData.influencerCount }}
                    <p-button
                      @click="
                        $router.push(
                          '/influencer-campaign/list/' + campaignData._id
                        )
                      "
                      link
                      type="info"
                      >View</p-button
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <p-button
            @click="showAddTrackingLinkModal"
            round
            outline
            type="info"
            size="sm"
            >+ New Tracking Link</p-button
          >
        </div>
        <div class="row" style="width: 100%" v-if="trackingLinkList.length > 0">
          <div class="card" style="width: 100%">
            <div class="card-header">
              <h5>Tracking Links:</h5>
            </div>
            <div class="row">
              <div class="col-md-12" style="margin-left: 15px; padding: 15px">
                <el-table
                  :data="trackingLinkList"
                  class="table-striped"
                  stripe
                  border
                >
                  <el-table-column
                    label="Name"
                    property="data.name"
                    width="200"
                  ></el-table-column>
                  <el-table-column label="Landing Page" max-width="600">
                    <template slot-scope="props">
                      <div style="padding: 10px">
                        {{ props.row.trackingUrl }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="Edit" max-width="400">
                    <template slot-scope="props">
                      <p-button
                        round
                        outline
                        size="sm"
                        type="info"
                        @click="showTrackingLinkEditModal(props.row.data._id)"
                        >edit</p-button
                      >
                      <p-button
                        round
                        outline
                        size="sm"
                        type="info"
                        @click="
                          showTrackingLinkArchiveAlert(props.row.data._id)
                        "
                        style="margin-left: 5px"
                        >archive</p-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal
        :show.sync="editCampaignDetailsModal"
        type="notice"
        class="modal-custom"
        id="editCampaignModal"
      >
        <div v-if="editCampaignDetailsModal == true">
          <div>
            <h5 class="card-title">Edit Campaign</h5>
            <div
              class="alert alert-dismissible fade show"
              :class="campaignUpdateAlertType"
              v-if="showCampaignUpdateAlert == true"
              style="width: 100%"
            >
              <div
                v-for="alert in campaignUpdateAlertMsg"
                :key="alert"
                style="width: 100%"
              >
                <button
                  type="button"
                  aria-hidden="true"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <i class="nc-icon nc-simple-remove"></i>
                </button>

                <span>{{ alert }}</span>
              </div>
            </div>
            <div class="row" v-if="shopList !== null">
              <div class="col">
                <p>
                  <span> Select Store: </span>

                  <select
                    v-model="campaignShop"
                    @change="shopSelect"
                    class="custom-select"
                  >
                    <option value selected>select one:</option>
                    <option
                      v-for="option in shopList"
                      :value="option.shop"
                      :key="option._id"
                    >
                      {{ option.shop }}
                    </option>
                  </select>
                </p>
              </div>
            </div>

            <div class="typography-line-custom">
              <p>
                <span>Campaign Name:</span>
                <fg-input
                  placeholder="ex. BrandCo Influencer Campaign"
                  v-model="model.campaignName"
                  v-validate="modelValidations.campaignName"
                  name="campaignName"
                  id="campaignName_input"
                  type="text"
                  required
                ></fg-input>
              </p>
            </div>
            <div class="typography-line-custom">
              <p>
                <span>Campaign Description:</span>

                <textarea
                  placeholder="ex. New campaign to promote the latest product release."
                  name="campaignDescription"
                  v-model="model.campaignDescription"
                  v-validate="'required'"
                  style="width: 100%"
                  class="custom-textarea"
                  :error="getError('campaignDescription')"
                  type="text"
                  required
                ></textarea>
              </p>
            </div>
            <div class="typography-line-custom">
              <p>
                <span>Brand Description:</span>

                <textarea
                  placeholder="ex. Brand Co. creates the best products ever."
                  name="brandDescription"
                  v-model="model.brandDescription"
                  v-validate="'required'"
                  style="width: 100%"
                  class="custom-textarea"
                  :error="getError('brandDescription')"
                  type="text"
                  required
                ></textarea>
              </p>
            </div>
            <div class="typography-line-custom">
              <div class="form-group">
                <p>
                  <span>Campaign Start:</span>
                </p>

                <div v-if="campaignStarted == false">
                  <datepicker
                    v-model="campaignStart"
                    placeholder="Select Date:"
                    name="campaignStart"
                    input-class="calendar-input-custom"
                    format="M/d/yy"
                  ></datepicker>
                </div>
                <div v-else>{{ this.campaignStart }}</div>
              </div>
              <div>
                <span>Campaign End:</span>
              </div>
              <div
                class="row"
                style="padding-left: 10px; margin: 0px; padding: 0px"
              >
                <div class="custom-radio-fieldset">
                  <input
                    type="radio"
                    id="ongoing"
                    value="ongoing"
                    v-model="endCampaignType"
                    @click="setCampaignEnd('ongoing')"
                  />
                  <label for="ongoing">Ongoing</label>
                  <br />
                </div>

                <div class="custom-radio-fieldset">
                  <input
                    type="radio"
                    id="end_date"
                    value="end_date"
                    v-model="endCampaignType"
                    @click="setCampaignEnd('end_date')"
                  />
                  <label for="end_date">End Date</label>
                </div>
              </div>
              <div class="row" style="padding: 15px">
                <div v-if="showDate == true">
                  <datepicker
                    placeholder="Select Date:"
                    v-model="campaignEnd"
                    name="campaignEnd"
                    input-class="calendar-input-custom"
                    format="M/d/yy"
                  ></datepicker>
                </div>
              </div>
            </div>
            <!--<div class="typography-line-custom">
              <p>
                <span style="margin-top:0px;">Landing Page:</span>
                <fg-input
                  placeholder="eg. https://brandco.com/landingpage"
                  v-model="model.landingPage"
                ></fg-input>
              </p>
            </div>-->
            <div class="row">
              <p-button color="success" class="mr-4" @click="onCampaignSubmit"
                >SAVE Campaign</p-button
              >
            </div>
          </div>
        </div>
      </modal>
      <modal
        :show.sync="addTrackingLinkModal"
        type="notice"
        class="modal-custom"
      >
        <div>
          <h5 class="card-title" style="margin: 0px">Add Tracking Link:</h5>
          <hr />
          <p style="font-size: 12px">
            <strong> Available tokens:</strong> <br />
            Instagram Profile: [[instagram]] <br />
            Influencer Id: [[influencer]] <br />
            Campaign Name: [[campaign_name]] <br />
            Campaign Id: [[campaign]] <br /><br />

            Add token to any "UTM" field below to dynamically insert variable
            into tracking link.
          </p>
          <hr />
          <div
            class="alert alert-dismissible fade show"
            :class="alertType"
            v-if="addTrackingLinkAlert == true"
            style="width: 100%"
          >
            <div
              v-for="alert in addTrackingLinkErrors"
              :key="alert"
              style="width: 100%"
            >
              <button
                type="button"
                aria-hidden="true"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <i class="nc-icon nc-simple-remove"></i>
              </button>

              <span>{{ alert }}</span>
            </div>
          </div>

          <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
          </div>-->
          <div class="typography-line-custom">
            <p>
              <span>Tracking Link Name:</span>
              <fg-input
                placeholder="e.g. Main Product Page or Homepage"
                v-model="newLinkName"
                name="linkName"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>Landing Page URL:</span>
              <fg-input
                placeholder="e.g. http://brandco.com/landingpage"
                v-model="newLandingPage"
                name="landingPage"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_campaign:</span>
              <fg-input
                placeholder
                v-model="newUtmCampaign"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_source:</span>
              <fg-input
                placeholder
                v-model="newUtmSource"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_medium:</span>
              <fg-input
                placeholder
                v-model="newUtmMedium"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_term:</span>
              <fg-input
                placeholder
                v-model="newUtmTerm"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_content:</span>
              <fg-input
                placeholder
                v-model="newUtmContent"
                type="text"
                required
              ></fg-input>
            </p>
          </div>

          <div class="row">
            <p-button color="success" class="mr-4" @click="trackingLinkCreate"
              >SAVE</p-button
            >
          </div>
        </div>
      </modal>
      <modal
        :show.sync="editTrackingLinkModal"
        type="notice"
        class="modal-custom"
      >
        <div>
          <h5 class="card-title" style="margin: 0px">Edit Tracking Link:</h5>
          <hr />
          <p style="font-size: 12px">
            Available tokens: <br />
            Instagram Profile: [[instagram]] <br />
            Influencer Id: [[influencer]] <br />
            Camaign Name: [[campaign_name]] <br />
            Camaign Id: [[campaign]] <br /><br />

            Add token to any "UTM" field below to dynamically insert variable
            into tracking link.
          </p>
          <hr />
          <div
            class="alert alert-dismissible fade show"
            :class="alertType"
            v-if="addTrackingLinkAlert == true"
            style="width: 100%"
          >
            <div
              v-for="alert in addTrackingLinkErrors"
              :key="alert"
              style="width: 100%"
            >
              <button
                type="button"
                aria-hidden="true"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <i class="nc-icon nc-simple-remove"></i>
              </button>

              <span>{{ alert }}</span>
            </div>
          </div>

          <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
          </div>-->
          <div class="typography-line-custom">
            <p>
              <span>Tracking Link Name:</span>
              <fg-input
                placeholder="e.g. Main Product Page or Homepage"
                v-model="editLinkName"
                name="linkName"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>Landing Page URL:</span>
              <fg-input
                placeholder="e.g. http://brandco.com/landingpage"
                v-model="editLandingPage"
                name="landingPage"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_campaign:</span>
              <fg-input
                placeholder
                v-model="editUtmCampaign"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_source:</span>
              <fg-input
                placeholder
                v-model="editUtmSource"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_medium:</span>
              <fg-input
                placeholder
                v-model="editUtmMedium"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_term:</span>
              <fg-input
                placeholder
                v-model="editUtmTerm"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_content:</span>
              <fg-input
                placeholder
                v-model="editUtmContent"
                type="text"
                required
              ></fg-input>
            </p>
          </div>

          <div class="row">
            <p-button color="success" class="mr-4" @click="trackingLinkUpdate"
              >SAVE</p-button
            >
          </div>
        </div>
      </modal>
      <modal
        :show.sync="archiveTrackingLinkConfirmAlert"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <p style="text-align: center">Confirm Delete Tracking Link?</p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="trackingLinkArchive(currentEditLink[0].data._id)"
              style="margin: 10px"
              size="sm"
              >Yes, Delete</p-button
            >
            <p-button
              round
              text
              @click="archiveTrackingLinkConfirmAlert = false"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import {
  influencerCampaignReadApi,
  influencerCampaignUpdateApi,
  influencerCampaignTrackingCreateApi,
  influencerCampaignTrackingListApi,
  influencerCampaignTrackingUpdateApi,
  trackingLinkTemplateCreateApi,
  trackingLinkTemplateListApi,
  trackingLinkTemplateUpdateApi,
  clientStoreListApi,
} from "@/config/appSettings";
import {
  TimeLine,
  TimeLineItem,
  Badge,
  Modal,
} from "src/components/UIComponents";
import { Select, Option } from "element-ui";

import Datepicker from "vuejs-datepicker";
export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Datepicker,
  },
  data: () => ({
    auth: null,
    campaignStartForm: null,
    loadingOverlay: false,
    loadingOverlayText: null,
    campaign: null,
    email: null,
    campaignUpdateAlertMsg: null,
    campaignUpdateAlertType: null,
    showCampaignUpdateAlert: false,
    alertMsg: null,
    showAlert: false,
    alertType: null,
    displayAlert: false,
    saveOverlay: null,
    campaignId: null,
    brandDescription: null,
    campaignName: null,
    campaignDescription: null,
    campaignStart: null,
    camapignStartString: null,
    campaignEndString: "ongoing",
    campaignEnd: "ongoing",
    landingPage: null,
    trackingParams: null,
    showDate: false,
    endCampaignType: "ongoing",
    campaignData: null,
    campaignStarted: true,
    loadingOverlay: false,
    loadingOverlayText: null,
    editCampaignDetailsModal: false,
    addTrackingLinkModal: false,
    addTrackingLinkAlert: false,
    addTrackingLinkErrors: [],
    newLandingPage: null,
    newLinkName: null,
    newUtmCampaign: null,
    newUtmSource: null,
    newUtmMedium: null,
    newUtmTerm: null,
    newUtmContent: null,
    editLandingPage: null,
    editLinkName: null,
    editUtmCampaign: null,
    editUtmSource: null,
    editUtmMedium: null,
    editUtmTerm: null,
    editUtmContent: null,
    editTrackingLinkModal: false,
    trackingLinkList: [],
    archiveTrackingLinkConfirmAlert: false,
    currentEditLink: null,
    shopList: null,
    selectedShop: null,
    defaultSelectShop: "Select One",
    campaignShop: null,
    model: {
      brandDescription: null,
      campaignName: null,
      campaignDescription: null,
      campaignStart: null,
      campaignEnd: "ongoing",
      influencerDiscount: null,
      influencerDiscountType: null,
      influencerCommission: null,
      influencerCommissionType: null,
      followerDiscount: null,
      followerDiscountType: null,
      landingPage: null,
      trackingParams: null,
    },
    modelValidations: {
      brandDescription: {
        required: true,
      },
      campaignName: {
        required: true,
      },
      campaignDescription: {
        required: true,
      },
      landingPage: {},
    },
    trackingLinkModel: {
      newLandingPage: null,
      newLinkName: null,
      newUtmCampaign: null,
      newUtmSource: null,
      newUtmMedium: null,
      newUtmTerm: null,
      newUtmContent: null,
    },
    trackingLinkModelValidations: {
      landingPage: {
        required: true,
        url: { require_protocol: true },
      },
      linkName: {
        required: true,
      },
    },
  }),
  name: "InfluencerCampaignDetail",
  methods: {
    getError(fieldName) {
      //console.log("ERRORS FOUND: ", this.errors.first(fieldName));
      try {
        return this.errors.first(fieldName);
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        try {
          //console.log("CHECKING IS VALID:", isValid);
          //console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
        }
      });
    },
    async showAddTrackingLinkModal() {
      this.addTrackingLinkModal = true;
      this.newLandingPage = null;
      this.newLinkName = null;
      this.newUtmCampaign = null;
      this.newUtmSource = null;
      this.newUtmMedium = null;
      this.newUtmTerm = null;
      this.newUtmContent = null;
    },
    async showEditCampaignModal(linkId) {
      this.editCampaignDetailsModal = true;
      this.editCampaignAlertMsg = null;
      this.editCampaignAlertType = null;
      this.editCampaignAlert = false;
    },
    async showTrackingLinkEditModal(linkId) {
      this.editTrackingLinkModal = true;
      this.editTrackingLinkAlertMsg = null;
      this.editTrackingLinkAlertType = null;
      this.editTrackingLinkAlert = false;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x.data._id == linkId;
      });
      //console.log("EDIT LINK DATA:", this.currentEditLink);
      if (this.currentEditLink.length > 0) {
        this.editLandingPage = this.currentEditLink[0].data.landingPage;
        this.editLinkName = this.currentEditLink[0].data.name;
        this.editUtmCampaign = this.currentEditLink[0].data.utmCampaign;
        this.editUtmSource = this.currentEditLink[0].data.utmSource;
        this.editUtmMedium = this.currentEditLink[0].data.utmMedium;
        this.editUtmTerm = this.currentEditLink[0].data.utmTerm;
        this.editUtmContent = this.currentEditLink[0].data.utmContent;
      }
    },
    async showTrackingLinkArchiveAlert(linkId) {
      this.archiveTrackingLinkConfirmAlert = true;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x.data._id == linkId;
      });
    },
    async trackingLinkCreate() {
      //console.log("CREATING TRACKING LINK");
      this.addTrackingLinkErrors = [];
      if (this.newLinkName == null || typeof this.newLinkName == "undefined") {
        this.addTrackingLinkErrors.push("Tracking link name required.");
      }
      if (
        this.newLandingPage == null ||
        typeof this.newLandingPage == "undefined"
      ) {
        this.addTrackingLinkErrors.push("Landing page required.");
      }
      if (this.addTrackingLinkErrors.length > 0) {
        this.addTrackingLinkAlert = true;
        this.alertType = "alert-danger";
        return;
      }
      let newTrackingLink = {};
      newTrackingLink.campaign = this.$route.params.campaignId;
      newTrackingLink.landingPage = this.newLandingPage;
      newTrackingLink.usertoken = this.auth;
      newTrackingLink.name = this.newLinkName;
      if (
        this.newUtmSource !== null &&
        typeof this.newUtmSource !== "undefined"
      ) {
        newTrackingLink.utmSource = this.newUtmSource;
      }
      if (
        this.newUtmCampaign !== null &&
        typeof this.newUtmCampaign !== "undefined"
      ) {
        newTrackingLink.utmCampaign = this.newUtmCampaign;
      }

      if (
        this.newUtmMedium !== null &&
        typeof this.newUtmMedium !== "undefined"
      ) {
        newTrackingLink.utmMedium = this.newUtmMedium;
      }

      if (this.newUtmTerm !== null && typeof this.newUtmTerm !== "undefined") {
        newTrackingLink.utmTerm = this.newUtmTerm;
      }

      if (
        this.newUtmContent !== null &&
        typeof this.newUtmContent !== "undefined"
      ) {
        newTrackingLink.utmCampaign = this.newUtmContent;
      }

      //console.log("SENDING:", newTrackingLink);
      let newTrackingLinkResponse = await axios.post(
        trackingLinkTemplateCreateApi,
        newTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", newTrackingLinkResponse);
      if (newTrackingLinkResponse.data.success == true) {
        this.addTrackingLinkModal = false;
        await this.loadTrackingLinks();
      }
    },
    async trackingLinkUpdate() {
      //console.log("CREATING TRACKING LINK");
      this.editTrackingLinkErrors = [];
      if (
        this.editLinkName == null ||
        typeof this.editLinkName == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Tracking link name required.");
      }
      if (
        this.editLandingPage == null ||
        typeof this.editLandingPage == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Landing page required.");
      }
      if (this.editTrackingLinkErrors.length > 0) {
        this.editTrackingLinkAlert = true;
        this.alertType = "alert-danger";
        return;
      }
      let updateTrackingLink = {};
      updateTrackingLink.link = this.currentEditLink[0].data._id;

      updateTrackingLink.landingPage = this.editLandingPage;
      updateTrackingLink.usertoken = this.auth;
      updateTrackingLink.name = this.editLinkName;
      if (
        this.editUtmSource !== null &&
        typeof this.editUtmSource !== "undefined"
      ) {
        updateTrackingLink.utmSource = this.editUtmSource;
      }
      if (
        this.editUtmCampaign !== null &&
        typeof this.editUtmCampaign !== "undefined"
      ) {
        updateTrackingLink.utmCampaign = this.editUtmCampaign;
      }

      if (
        this.editUtmMedium !== null &&
        typeof this.editUtmMedium !== "undefined"
      ) {
        updateTrackingLink.utmMedium = this.editUtmMedium;
      }

      if (
        this.editUtmTerm !== null &&
        typeof this.editUtmTerm !== "undefined"
      ) {
        updateTrackingLink.utmTerm = this.editUtmTerm;
      }

      if (
        this.editUtmContent !== null &&
        typeof this.editUtmContent !== "undefined"
      ) {
        updateTrackingLink.utmCampaign = this.editUtmContent;
      }

      //console.log("SENDING:", updateTrackingLink);
      let updateTrackingLinkResponse = await axios.post(
        trackingLinkTemplateUpdateApi,
        updateTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", updateTrackingLinkResponse);
      if (updateTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.editTrackingLinkModal = false;
        await this.loadTrackingLinks();
      }
    },
    async trackingLinkArchive(linkId) {
      //console.log("ARCHIVING TRACKING LINK");

      let archiveTrackingLink = {};
      archiveTrackingLink.link = linkId;

      archiveTrackingLink.status = "archived";
      archiveTrackingLink.usertoken = this.auth;

      //console.log("SENDING:", archiveTrackingLink);
      let archiveTrackingLinkResponse = await axios.post(
        trackingLinkTemplateUpdateApi,
        archiveTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", archiveTrackingLinkResponse);
      if (archiveTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.archiveTrackingLinkConfirmAlert = false;
        await this.loadTrackingLinks();
      }
    },
    async loadCampaign() {
      try {
        let influencerCampaignResponse = await axios.get(
          `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`
        );

        //console.log("CAMPAIGN DETAILS:", influencerCampaignResponse.data);

        if (influencerCampaignResponse.data.success === true) {
          this.loadingOverlay = false;
          this.loadingOverlayText = null;
          this.campaignData = influencerCampaignResponse.data.result;

          this.model.client = this.campaignData.business._id;
          this.campaignId = this.campaignData._id;
          this.model.brandDescription = this.campaignData.brandDescription;
          this.model.campaignName = this.campaignData.name;
          this.model.campaignDescription = this.campaignData.campaignDescription;
          //console.log("CAMPAIGN: ", this.campaignData.startDate);
          if (
            typeof this.campaignData.startDate !== "undefined" &&
            this.campaignData.startDate !== null
          ) {
            this.campaignStartString = moment(
              this.campaignData.startDate
            ).format("MM/DD/YYYY");
            this.campaignStart = moment(this.campaignData.startDate).format(
              "MM/DD/YYYY"
            );
          }

          let today = moment().format("YYYY-MM-DD");
          if (moment(this.campaignStart).isAfter(today)) {
            this.campaignStarted = false;
          }
          this.campaignEnd = this.campaignData.endDate;

          if (this.campaignData.endDate !== "ongoing") {
            this.campaignEndString = moment(this.campaignEnd).format(
              "MM/DD/YYYY"
            );
            this.endCampaignType = "end_date";
            this.showDate = true;
          }

          this.model.landingPage = this.campaignData.landingPage;
          this.trackingParams = this.campaignData.trackingParams;
          this.loadingOverlay = false;
          this.loadingText = null;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadTrackingLinks() {
      let trackingLinkTemplateList = `${trackingLinkTemplateListApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;
      //console.log("TRACKING LINK TEMPLATE:", trackingLinkTemplateList);
      let trackingLinkListResponse = await axios.get(trackingLinkTemplateList);
      //console.log("TRACKING LINK LIST:", trackingLinkListResponse);
      if (trackingLinkListResponse.data.result.length > 0) {
        this.trackingLinkList = trackingLinkListResponse.data.result.map(
          (x) => {
            let thisLink = {};
            let linkUrl = x.landingPage;
            let utmCodes = [];
            let utmString;
            if (
              typeof x.utmCampaign != "undefined" &&
              x.utmCampaign.trim() !== ""
            ) {
              utmCodes.push(`utm_campaign=${x.utmCampaign}`);
            }
            if (
              typeof x.utmSource != "undefined" &&
              x.utmSource.trim() !== ""
            ) {
              utmCodes.push(`utm_source=${x.utmSource}`);
            }
            if (
              typeof x.utmMedium != "undefined" &&
              x.utmMedium.trim() !== ""
            ) {
              utmCodes.push(`utm_medium=${x.utmMedium}`);
            }
            if (typeof x.utmTerm != "undefined" && x.utmTerm.trim() !== "") {
              utmCodes.push(`utm_term=${x.utmTerm}`);
            }
            if (
              typeof x.utmContent != "undefined" &&
              x.utmContent.trim() !== ""
            ) {
              utmCodes.push(`utm_content=${x.utmContent}`);
            }
            if (utmCodes.length > 1) {
              utmString = utmCodes.join("&");
            }
            if (utmCodes.length === 1) {
              utmString = utmCodes[0];
            }
            linkUrl = `${linkUrl}/?${utmString}`;
            thisLink.trackingUrl = linkUrl;

            thisLink.data = x;
            return thisLink;
          }
        );
      }
    },

    async loadShopifyShops() {
      try {
        let storeLookupUrl = `${clientStoreListApi}/?usertoken=${this.auth}&client=${this.campaignData.clientId}`;
        let storeLookupResponse = await axios.get(storeLookupUrl);
        //console.log("STORE LOOKUP RESPONSE:", storeLookupResponse.data.result);
        if (storeLookupResponse.data.success == true) {
          this.shopList = storeLookupResponse.data.result.filter((x) => {
            return x.status == "active";
          });
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async shopSelect() {
      console.log("SELECTED...", this.campaignShop);
      let shopMatch = this.shopList.filter((x) => {
        return x.shop == this.campaignShop;
      });
      if (shopMatch.length > 0) {
        this.selectedShop = shopMatch[0];
      }
      //console.log("SELECTED SHOP:", this.selectedShop);
    },
    async onCampaignSubmit(e) {
      //console.log("SAVING...");
      try {
        e.preventDefault();
        let self = this;
        self.loadingText = "SAVING CAMPAIGN...";
        self.loadingOverlay = true;
        //console.log("CHECKING VALIDATION:", await this.$validator.validateAll());
        let formErrors = [];
        let today = moment().format("YYYY-MM-DD");
        //console.log("TODAYS DATE:", today);
        if (this.campaignStarted == false) {
          if (moment(this.campaignStart).isBefore(today)) {
            formErrors.push("Start date cannot be set before today.");
          }
        }
        if (this.endCampaignType === "end_date") {
          if (event === null || typeof event === "undefined") {
            formErrors.push("Select campaign end date.");
          }
          if (moment(this.campaignEnd).isBefore(this.campaignStart)) {
            formErrors.push("End date must be after start date");
          }
        }
        if (this.endCampaignType == "ongoing") {
          this.campaignEnd = "ongoing";
        }

        if (
          this.model.campaignName == null ||
          this.model.campaignName.trim() == "" ||
          typeof this.model.campaignName == "undefined"
        ) {
          formErrors.push("Campaign Name Required");
        }
        if (
          this.model.campaignDescription == null ||
          this.model.campaignDescription.trim() == "" ||
          typeof this.model.campaignDescription == "undefined"
        ) {
          formErrors.push("Campaign Description Required");
        }
        if (
          this.model.brandDescription == null ||
          this.model.brandDescription.trim() == "" ||
          typeof this.model.brandDescription == "undefined"
        ) {
          formErrors.push("Brand Description Required");
        }
        if (
          this.campaignStart == null ||
          typeof this.campaignStart == "undefined"
        ) {
          //console.log("CAMPAIGN START:", this.campaignStart);
          formErrors.push("Campaign Start Date Required");
        }
        if (
          this.campaignEnd == null ||
          typeof this.campaignEnd == "undefined"
        ) {
          formErrors.push("Campaign End Date Required");
        }
        if (formErrors.length > 0) {
          //onsole.log("FORM ERRORS:", formErrors);
          this.showCampaignUpdateAlert = true;
          this.campaignUpdateAlertMsg = formErrors;
          this.campaignUpdateAlertType = "alert-danger";

          let modalTop = document.getElementById("editCampaignModal");
          modalTop.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start",
          });
          //this.$refs["campaignEditModal"].scrollTo(0, 0);
          return;
        }

        if ((await this.$validator.validateAll()) === true) {
          let formInfo = {};
          formInfo.id = this.campaignId;
          formInfo.usertoken = this.auth;
          formInfo.brandDescription = self.model.brandDescription;
          formInfo.name = self.model.campaignName;
          formInfo.campaignDescription = self.model.campaignDescription;
          if (self.campaignStart !== null) {
            formInfo.startDate = self.campaignStart;
          }
          formInfo.endDate = self.campaignEnd;
          //console.log("SELECTED SHOP:", this.selectedShop);
          if (this.selectedShop !== null) {
            formInfo.shopId = this.selectedShop._id;
          }

          formInfo.landingPage = self.model.landingPage;
          try {
            if (self.trackingParams.trim().length > 0) {
              formInfo.trackingParams = self.trackingParams;
            }
          } catch (err) {}

          //console.log("FORM INFO:", formInfo);

          let campaignResponse = await axios.post(
            influencerCampaignUpdateApi,
            formInfo
          );
          //console.log("HERE IS THE RESULT: ", campaignResponse.data);
          //console.log(  "HERE IS THE INFO FROM FIREBASE: ",firebase.auth().currentUser.uid );
          if (campaignResponse.data.success === true) {
            this.editCampaignDetailsModal = false;
            this.loadCampaign();
            self.loadingOverlay = false;
            self.alertMsg = ["Profile Updated."];
            self.alertType = "alert-success";
            self.showAlert = true;
            window.scrollTo(0, 0);

            // FORWARD TO DETAIL PAGE
          }
        } else {
          //console.log("VALIDATE FAILED..:(");
          self.loadingOverlay = false;
          self.alertMsg = ["Please complete all fields."];
          self.alertType = "alert-danger";
          self.displayAlert = true;
          window.scrollTo(0, 0);
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async campaignDateFormat(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    async setCampaignEnd(event) {
      //console.log(event);
      try {
        if (event === "ongoing") {
          this.showDate = false;
          this.endCampaignType = "ongoing";
          this.campaignEnd = "ongoing";
          return;
        }
        if (event === "end_date") {
          this.showDate = true;
          this.campaignEnd = null;
          this.endCampaignType = "end_date";
          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERR:", err);
      }
    },
    async campaignEndCheck(event) {
      try {
        if (this.endCampaignType === "end_date") {
          if (event === null || typeof event === "undefined") {
            return "Select campaign end date.";
          }
          if (moment(this.campaignEnd).isBefore(this.campaignStart)) {
            return "End date must be after start date";
          }
          return true;
        }
        if (this.endCampaignType === "ongoing") {
          this.campaignEnd = "ongoing";
        }
        return true;
      } catch (err) {
        console.log("THERE WAS AN ERR:", err);
      }
    },
    async campaignStartCheck() {
      try {
        let today = moment().format("YYYY-MM-DD");
        //console.log("TODAYS DATE:", today);
        if (event === null || typeof event === "undefined") {
          return "Select campaign start date.";
        }
        if (moment(this.campaignStart).isBefore(today)) {
          return "Start date cannot be set before today.";
        }
        return true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    influencerDiscountTypeCheck(event) {
      //console.log(event);

      try {
        if (this.influencerDiscount !== 0 && this.influencerDiscount > 0) {
          if (event === null || typeof event === "undefined") {
            return "Select influnecer discount type.";
          }
          return true;
        }
        return true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    followerDiscountTypeCheck(event) {
      //console.log(event);
      try {
        if (this.followerDiscount !== 0 && this.followerDiscount > 0) {
          if (event === null || typeof event === "undefined") {
            return "Select follower discount type.";
          }
          return true;
        }
        return true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    influencerCommissionTypeCheck(event) {
      try {
        if (this.influencerComission !== 0 && this.influencerCommission > 0) {
          if (event === null || typeof event === "undefined") {
            return "Select ambassador commission type.";
          }
          return true;
        }
        return true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    toggleForm() {
      this.showForm = true;
      this.showIntro = false;
    },

    percentDollarString(transactionType) {
      try {
        if (transactionType === "percent") {
          return "% percent";
        }
        if (transactionType === "dollars") {
          return "$ dollars";
        }
        return "";
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      await this.loadCampaign();
      //console.log("CAMPAIGN DATA", this.campaignData);
      this.loadTrackingLinks();
      await this.loadShopifyShops();
      if (typeof this.campaignData.shopId !== "undefined") {
        let shopMatch = this.shopList.map((x) => {
          if (x._id === this.campaignData.shopId) {
            return x.shop;
          }
          return [];
        });
        if (shopMatch.length > 0) {
          this.campaignShop = shopMatch[0];
        }
      }
    },
  },

  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
};
</script>

<style scoped>
.field-bg {
  background-color: white;
  margin: 10px;
}
</style>